import Vue from 'vue';

function toggleAddressFieldByCountry(el, value) {
    // value = [country num_code, field_name]
    let no_locality = [840, 124, 36], // usa, canada, australia
        no_county = [276, 40, 250, 528, 56]; // germany, austria, france, netherland, belgium
    if (!!el) {
        let hide = !!value[0] && !!value[1] && (
            (value[1] == 'locality' && no_locality.findIndex(obj => {
                return obj == value[0]
            }) >= 0) ||
            (value[1] == 'county_code' && no_county.findIndex(obj => {
                return obj == value[0]
            }) >= 0)
        );
        if (!!hide) {
            $(el).addClass('displayNone');
        }
        else {
            $(el).removeClass('displayNone');
        }
    }
}

export const NDCountryDependent =
    {
        bind: function (el, binding, vnode) {
            toggleAddressFieldByCountry(el, binding.value)
        },
        update: function (el, binding, vnode) {
            toggleAddressFieldByCountry(el, binding.value)
        }
    }
